module.exports = __webpack_public_path__ + "static/img/40009 (5).f4535af.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40009 (5).webp
// module id = lyya
// module chunks = 14